import TypeSelect from "@/components/form/type-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";
import type { OrderType } from "@/types/openapi-enum";

export type OrderTypeFieldProps = PickerFieldProps<OrderType>;

export const OrderTypeField = makePickerField<OrderType>({
  name: "OrderTypeField",
  control: TypeSelect,
  popout: true,
});
